import { render, staticRenderFns } from "./cusTransfer.vue?vue&type=template&id=bd9146ac&scoped=true&"
import script from "./cusTransfer.vue?vue&type=script&lang=js&"
export * from "./cusTransfer.vue?vue&type=script&lang=js&"
import style0 from "./cusTransfer.vue?vue&type=style&index=0&id=bd9146ac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9146ac",
  null
  
)

export default component.exports